import { render, staticRenderFns } from "./ReceptionList.vue?vue&type=template&id=11cdf22d&"
import script from "./ReceptionList.vue?vue&type=script&lang=js&"
export * from "./ReceptionList.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports